import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { DistributionStatusBarTypeEnum } from 'shared/enums/distribution-status-bar-type.enum';
import { TrackingItemStatus } from 'shared/enums/tracking-item-status.enum';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';
import { ChannelMonitoringStatus } from 'exports/interfaces/channel-monitoring-status.enum';

@Component({
    selector: 'app-distribution-tracking-status-renderer',
    templateUrl: './distribution-tracking-status-renderer.component.html',
    styleUrls: ['./distribution-tracking-status-renderer.component.scss'],
    standalone: false,
})
export class DistributionTrackingStatusRendererComponent implements ICellRendererAngularComp {
    protected displayValue!: number | boolean;
    protected statusType!: DistributionStatusBarTypeEnum;
    protected tooltip?: string;
    protected trackingItemStatus?: TrackingItemStatus;
    protected channelMonitoringStatus?: ChannelMonitoringStatus;
    protected customTooltipMessage: string | undefined;

    agInit(params: ICellRendererParams & { customTooltipMessage: string | undefined }): void {
        this.statusType = params.data.group ? DistributionStatusBarTypeEnum.BAR : DistributionStatusBarTypeEnum.ICON;
        this.displayValue = params.data.group ? params.value : (params.data.isSuccessful ?? params.value === 100);
        this.tooltip = typeof this.displayValue === 'boolean' ? params.data.message : undefined;
        this.trackingItemStatus = params.data.trackingItemStatus
            ? params.data.trackingItemStatus
            : params.data.channelMonitoringStatus
              ? null
              : TrackingItemStatus.COMPLETED;
        this.channelMonitoringStatus = params.data.channelMonitoringStatus ?? ChannelMonitoringStatus.UNKNOWN;
        this.customTooltipMessage = params.customTooltipMessage;
    }

    refresh(params: ICellRendererParams): boolean {
        return false;
    }

    protected readonly DistributionStatusBarTypeEnum = DistributionStatusBarTypeEnum;
    protected readonly TrackingItemStatusEnum = TrackingItemStatus;
    protected readonly ChannelMonitoringStatusEnum = ChannelMonitoringStatus;
}
